module.exports = __webpack_public_path__ + "avatar_all.png?c5a509acee8aab3a1f62e16ea1204ffc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/inspinia/img/landing/avatar_all.png
// module id = 615
// module chunks = 0